import {
  Box,
  Button,
  Checkbox,
  HStack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Input,
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalOverlay,
  ModalHeader,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Spinner,
} from "@chakra-ui/react";
import { ROLES } from "keys";
import React, { useMemo, useState, useEffect, useCallback } from "react";
import debounce from "lodash/debounce";

import { axiosInstance } from "utils/axios";

const TableItem = ({ user, updateUser, setUserSelected }) => {
  const [item, setItem] = useState(user);

  const isRoleChange = () => {
    return item.role !== user.role;
  };

  const changeRole = (role) => {
    const currentRole = item.role;
    setItem((pre) => ({
      ...pre,
      role: currentRole % role === 0 ? currentRole / role : currentRole * role,
    }));
  };

  return (
    <Tr>
      <Td>{item.email}</Td>
      <Td>{item.firstname}</Td>
      <Td>{item.lastname}</Td>
      <Td textAlign="center">
        <Checkbox
          defaultChecked={item.role % ROLES.ADMIN === 0 ? true : false}
          onChange={() => changeRole(ROLES.ADMIN)}
        />
      </Td>
      <Td textAlign="center">
        <Checkbox
          defaultChecked={
            item.role % ROLES.EDITOR_IN_CHIEF === 0 ? true : false
          }
          onChange={() => changeRole(ROLES.EDITOR_IN_CHIEF)}
        />
      </Td>
      <Td textAlign="center">
        <Checkbox
          defaultChecked={item.role % ROLES.PUBLISHER === 0 ? true : false}
          onChange={() => changeRole(ROLES.PUBLISHER)}
        />
      </Td>
      <Td textAlign="center">
        <Checkbox
          defaultChecked={item.role % ROLES.EDITOR === 0 ? true : false}
          onChange={() => changeRole(ROLES.EDITOR)}
        />
      </Td>
      <Td textAlign="center">
        <Checkbox
          defaultChecked={item.role % ROLES.REVIEWER === 0 ? true : false}
          onChange={() => changeRole(ROLES.REVIEWER)}
        />
      </Td>
      <Td textAlign="center">
        <Checkbox
          defaultChecked={item.role % ROLES.AUTHOR === 0 ? true : false}
          onChange={() => changeRole(ROLES.AUTHOR)}
        />
      </Td>
      
      <Td isNumeric>
        {isRoleChange() && (
          <Button colorScheme="blue" onClick={() => updateUser(item)}>
            Save
          </Button>
        )}
        <Button onClick={() => setUserSelected(item)} colorScheme="teal">
          View
        </Button>
      </Td>
    </Tr>
  );
};

export const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [userSelected, setUserSelected] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get(`/auth/users/`, {
        params: {
          q: searchQuery,
        },
      })
      .then((res) => {
        setUsers(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [searchQuery]);

  const updateUser = (user) => {
    axiosInstance
      .put(`/auth/users/${user._id}`, user)
      .then((res) => {
        const idx = users.findIndex((u) => u._id === user._id);
        if (idx !== -1) {
          setUsers([
            ...users.slice(0, idx),
            res.data,
            ...users.slice(idx + 1, users.length),
          ]);
        }
        alert("update success");
      })
      .catch((err) => console.log(err));
  };

  const debounceFn = useCallback(debounce(setSearchQuery, 1000), []);

  function handleChange(e) {
    setLoading(true);
    debounceFn(e.target.value);
  }

  return (
    <Box>
      <Modal
        size="xl"
        isOpen={!!userSelected}
        onClose={() => setUserSelected(undefined)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>User info</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {userSelected && (
              <Grid templateColumns="repeat(2, 1fr)" gap="4" minH="20">
                <GridItem>
                  <FormLabel>ID</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected._id}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Email</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.email}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Title</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.title}
                    isDisabled
                  />
                </GridItem>
                <GridItem></GridItem>

                <GridItem colStart="1">
                  <FormLabel>First Name</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.firstname}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Last Name</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.lastname}
                    isDisabled
                  />
                </GridItem>
                
                <GridItem>
                  <FormLabel>Institution</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.university}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Department</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.major}
                    isDisabled
                  />
                </GridItem>

                <GridItem>
                  <FormLabel>Country</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.country}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>City/Provine</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.city_provine}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Address</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.address}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Phone</FormLabel>
                  <Input
                    style={{
                      opacity: 1,
                    }}
                    value={userSelected.phone}
                    isDisabled
                  />
                </GridItem>
              </Grid>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box fontSize="2xl" fontWeight="bold" textAlign="center">
        User Management
      </Box>
      <Box maxW="80">
        <Input
          placeholder="Search"
          // value={searchQuery}
          onChange={(e) => handleChange(e)}
        />
      </Box>
      {!loading ? (
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Email</Th>
              <Th>First Name</Th>
              <Th>Last Name</Th>

            <Th textAlign="center">Is Admin</Th>
            <Th textAlign="center">Is Editor-in-Chief</Th>
            
            <Th textAlign="center">Is Publisher</Th>
            <Th textAlign="center">Is Editor</Th>
            <Th textAlign="center">Is Reviewer</Th>
            <Th textAlign="center">Is Author</Th>
            <Th isNumeric>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
            {users.map((user, idx) => (
            <TableItem
              key={idx}
              user={user}
              updateUser={updateUser}
              setUserSelected={setUserSelected}
            />
          ))}
        </Tbody>
      </Table>
      ) : (
        <Box textAlign="center">
          <Spinner />
        </Box>
      )}
    </Box>
  );
};
